import React from 'react'
import { AlertComponentProps } from 'react-alert'
import { IconButton } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';
import { AlertCloseSvg } from '@app/pages/Dashboard/assets/icons'
import { ReactComponent as CloseErrorSvg } from '@app/assets/icons/close-error.svg'
import { ReactComponent as CheckCircleSuccess } from '@app/assets/icons/checkCircleSuccess.svg'
import { AlertSystem } from './styled'


const SystemAlert: React.FC<AlertComponentProps> = ({
	options,
	message,
	close,
}: AlertComponentProps) => {
	return (
		<AlertSystem
			variant={'filled'}
			severity={options?.type}
			iconMapping={{
				error: <CloseErrorSvg />,
				success: <CheckCircleSuccess />,
				info: <InfoIcon />
			}}
			sx={{
				pointerEvents: 'auto',
				alignItems: 'center',
				margin: '1rem',
			}}
		>
			{message}
			<IconButton onClick={close} sx={{ ml: '25px' }}>
				{AlertCloseSvg}
			</IconButton>
		</AlertSystem>
	)
}

export default SystemAlert
